// extracted by mini-css-extract-plugin
export default {"button":"_22UmZ","formButton":"BqSQ3","form":"lwIvK","responses":"_86G+s","response":"v83IC","error":"nv7tX","summaryBlock":"BfCaf","fullButton":"QbS8K","title":"dbzJl"};